// Authorization utilities — the single source for role/access-level checks in the web app.
// Re-export the access-level predicates and resolver/labels from the shared package so
// no component compares raw role strings directly.
export {
  ACCESS_LEVEL_LABEL,
  AccessLevel,
  accessLevelFromScopeTier,
  isAdminTierUser,
  isAdminUser,
  isExternalAdminUser,
  isInternalAdminUser,
  isInternalBasicUser,
  isInternalUser,
  ROUTE_ROLES,
  resolveAccessLevel,
  rolesForAccessLevel,
} from '@steerfi/shared';

/** Returns true if user has any of the allowed roles (used for nav items). */
export const userHasType = (
  user: { roles?: string[] } | null | undefined,
  allowedTypes?: string[]
): boolean => {
  if (!allowedTypes || allowedTypes.length === 0) return true;
  const roles = user?.roles ?? [];
  return allowedTypes.some((role) => roles.includes(role));
};
